import { generateAsyncReducer } from '../../../utils';
import { EHomeActions } from './enums';
import { IHomeState } from './models';

export const HomeReducers = generateAsyncReducer<IHomeState>(EHomeActions.GET_HOME);
